import { Component, Input } from '@angular/core';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
@Component({
  selector: 'app-common-bulk-print',
  templateUrl: './common-bulk-print.component.html',
  styleUrls: ['./common-bulk-print.component.css']
})
export class CommonBulkPrintComponent {
  @Input() columns: any[] = []; // Table columns definition
  @Input() data: any[] = []; // Data to be displayed
  @Input() downloadPdf: boolean = true;
  @Input() print: boolean = true;
  @Input() columnsToExport: any[] = [];
  @Input() fileName: string = '';
  @Input() allRecords: any;
  @Input() exportData: any[] = [];
  getFilteredColumns(): any[] {
    if (!this.columnsToExport || this.columnsToExport.length === 0) {
      return this.columns;
    }
    return this.columns.filter(col => 
      this.columnsToExport.includes(col.id ?? col.key)
    );
  }

  // Utility to extract values (handles nested data)
  getValue(key: string, record: any): any {
    if (!record || !key) return '';
    
    const value = record[key];
    if (value === null || value === undefined) return '';

    switch (key) {
      case 'expenseAssociated':
        return value.map((v: any) => v.expense).filter(Boolean).join(', ');
      case 'invoiceLineItems':
        return value.map((v: any) => v.expense).filter(Boolean).join(', ');
      case 'invoiceLineItems':
        return value.map((v: any) => v.expense).filter(Boolean).join(', ');
      case 'venderInvoiceNumber':
        return value.map((v: any) => v.invoiceNumber).filter(Boolean).join(', ');
      case 'expenseModeMapping':
        return value.map((v: any) => v.expenseMode).filter(Boolean).join(', ');
      case 'approvalUser':
        return value.map((v: any) => `${v.name || ''} ${v.approvalStatus ? `(${v.approvalStatus})` : ''}`).filter(Boolean).join(', ');
      case 'attributes':
        return value.map((v: any) => v.quickCodeName).filter(Boolean).join(', ');
      case 'approvalHierarchy':
        return value.map((v: any) => {
          const des = v.designation || '';
          const cond = v.condition ? `(${v.condition})` : '';
          return `${des} ${cond}`.trim();
        }).filter(Boolean).join(', ');
      case 'userRole':
        return value.map((v: any) => v.roleDescription).filter(Boolean).join(', ');
      case 'warehouseList':
        return value.map((v: any) => {
          const client = v.clientName || '';
          const wh = v.warehouseName || '';
          return client && wh ? `${client} - ${wh}` : client || wh;
        }).filter(Boolean).join(', ');
      default:
        return Array.isArray(value)
          ? value.join(', ')
          : typeof value === 'object'
          ? JSON.stringify(value)
          : value;
    }
  }

  // Generate printable HTML content
  generatePrintContent(columns: any[], data: any[]): string {
    let content = `<html><head>
      <style>
        body { font-family: Arial, sans-serif; margin: 20px; }
        table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
        th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }
        th { background-color: #f0f0f0; font-weight: bold; width: 200px },
        td { width: calc(100% - 200px); }
      </style>
    </head><body>`;

    data.forEach(record => {
      content += `<table><tbody>`;
      columns.forEach(col => {
        const val = this.getValue(col.key, record);
        content += `<tr><th>${col.header}</th><td>${val}</td></tr>`;
      });
      content += `</tbody></table>`;
    });

    content += `</body></html>`;
    return content;
  }

  printRecords(): void {
    const columns = this.getFilteredColumns();
    const records = this.exportData?.length ? this.exportData : this.data;

    if (!records?.length) {
      console.error('No records available to print.');
      return;
    }

    const printContent = this.generatePrintContent(columns, records);
    const win = window.open('', '_blank');
    if (win) {
      win.document.write(printContent);
      win.document.close();
      win.focus();
      win.print();
    } else {
      console.error('Unable to open print window.');
    }
  }

  // PDF Download (supports bulk)
  downloadPDF(): void {
    const columns = this.getFilteredColumns();
    const records = this.exportData?.length ? this.exportData : this.data;

    if (!records?.length) {
      console.error('No records available for PDF export.');
      return;
    }

    const doc = new jsPDF();
    let y = 20;

    records.forEach(record => {
      const rows = columns.map(col => [col.header, this.getValue(col.key, record)]);
      (doc as any).autoTable({
        body: rows,
        startY: y,
        theme: 'grid',
        styles: { fontSize: 8 },
        columnStyles: { 0: { fontStyle: 'bold', cellWidth: 50 } }
      });
      y = (doc as any).lastAutoTable.finalY + 10;
    });

    doc.save(this.fileName || 'export.pdf');
  }
}
